import { payrollOverviewsListingRoutes } from './features/payroll-overviews-listing/payroll-overviews-listing.routes';
import { payrollOverviewDetailsRoutes } from './features/payroll-overviews-details/payroll-overview-details.routes';
export const payrollOverviewsRoutes = [
  {
    path: '/payroll-overviews',
    name: 'payroll-overviews',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "purchase-orders" */ './PayrollOverviews.vue'),
    children: [...payrollOverviewsListingRoutes, ...payrollOverviewDetailsRoutes]
  }
];
